/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedBody } from '../../models/paginated-body';

export interface GetPages$Params {

/**
 * UUID to identify the customer
 */
  customerId: string;

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;
  query?: string;

/**
 * limit for pagination
 */
  limit?: number;

/**
 * offset for pagination
 */
  offset?: number;
}

export function getPages(http: HttpClient, rootUrl: string, params: GetPages$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedBody>> {
  const rb = new RequestBuilder(rootUrl, getPages.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('svgId', params.svgId, {});
    rb.query('query', params.query, {"explode":false});
    rb.query('limit', params.limit, {"explode":false});
    rb.query('offset', params.offset, {"explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedBody>;
    })
  );
}

getPages.PATH = '/svgs/{svgId}/customers/{customerId}/journal';
